import { useDispatch, useSelector } from "react-redux";

import { FilterList } from "@mui/icons-material";

import { getPriceOfferSomStatusFilter } from "slices/priceOffer/priceOfferSelectors";
import { priceOfferActions, SomStatusFilterKey } from "slices/priceOffer/priceOfferSlice";

export const useGetSomStatusFilterParams = () => {
	const dispatch = useDispatch();
	const somStatusFilter = useSelector(getPriceOfferSomStatusFilter);
	const setSomStatusFilter = ({ key, value }) =>
		dispatch(
			priceOfferActions.setSomStatusFilter({
				...somStatusFilter,
				[key]: value,
			})
		);

	const somStatusFilterCheckboxesData = [
		{
			label: "Включена в БД СОМ",
			value: somStatusFilter[SomStatusFilterKey.SOM_INCLUDED],
			setValue: (value) =>
				setSomStatusFilter({
					value,
					key: SomStatusFilterKey.SOM_INCLUDED,
				}),
		},
		{
			label: "Исключена из БД СОМ",
			value: somStatusFilter[SomStatusFilterKey.SOM_EXCLUDED],
			setValue: (value) =>
				setSomStatusFilter({
					value,
					key: SomStatusFilterKey.SOM_EXCLUDED,
				}),
		},
		{
			label: "Без статуса БД СОМ",
			value: somStatusFilter[SomStatusFilterKey.WITHOUT_SOM_STATUS],
			setValue: (value) =>
				setSomStatusFilter({
					value,
					key: SomStatusFilterKey.WITHOUT_SOM_STATUS,
				}),
		},
	];

	const checkedSomStatusFilterCount = Object.values(somStatusFilter).filter(Boolean).length;
	const somStatusFilterOpenPopoverIcon = <FilterList sx={{ fontSize: "16px" }} />;
	const somStatusFilterPopoverProps = {
		anchorOrigin: {
			vertical: "bottom",
			horizontal: "left",
		},
		transformOrigin: {
			vertical: "top",
			horizontal: "left",
		},
	};

	return {
		somStatusFilterCheckboxesData,
		checkedSomStatusFilterCount,
		somStatusFilterOpenPopoverIcon,
		somStatusFilterPopoverProps,
	};
};
